import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { Icon, Tabs } from 'src/components/ui'
import { useActiveFilters } from 'src/zustand/stores/filters.store'

import styles from './Bottles.module.scss'
import { LotteryBottles, OtherBottles } from './pages'

const BottlesPage = () => {
  const toggleOpenFilters = useActiveFilters((state) => state.toggleOpenFilters)

  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const mode = searchParams.get('mode')

  return (
    <div className={styles.bottles_wrapper}>
      <div className={styles.bottles_header}>
        <h2>{t('bottles_page.bottles')}</h2>
        {mode === 'lottery' && (
          <button type='button' onClick={toggleOpenFilters}>
            <Icon name='filter' />
            <p>{t('bottles_page.filter')}</p>
          </button>
        )}
      </div>

      <Tabs
        titles={[
          { name: t('bottles_page.types.my'), mode: 'my' },
          { name: t('bottles_page.types.participate'), mode: 'participate' },
          { name: t('bottles_page.types.lottery'), mode: 'lottery' },
          { name: t('bottles_page.types.charitable'), mode: 'charitable' },
        ]}
      />

      {mode === 'my' && <OtherBottles variant='created' className={styles.bottles_items} />}
      {mode === 'participate' && <OtherBottles variant='participated' className={styles.bottles_items} />}
      {mode === 'charitable' && <OtherBottles variant='charitable' className={styles.bottles_items} />}
      {mode === 'lottery' && <LotteryBottles className={styles.bottles_items} />}
    </div>
  )
}

export default BottlesPage
